declare function overloadedConfig(string): any;

export default function getConfig(key: string, original: any) {
  if(typeof overloadedConfig === 'function'){
    return overloadedConfig(key);
  }

  return original;
}
